export const PLACEMENT_OVERVIEW_TABS = {
  ALL_STATUSES: 'allStatuses',
  PENDING_DECISIONS: 'pendingDecisions',
  IN_PROGRESS: 'inProgress',
  OVERDUE: 'overdue',
  CLOSED: 'closed',
  TRANSFERRED_IN: 'transferredIn',
} as const;

export type PlacementOverviewTab = (typeof PLACEMENT_OVERVIEW_TABS)[keyof typeof PLACEMENT_OVERVIEW_TABS];

export const DEFAULT_PLACEMENT_OVERVIEW_TAB = PLACEMENT_OVERVIEW_TABS.ALL_STATUSES;

export const isPlacementOverviewTab = (tab: string): tab is PlacementOverviewTab =>
  Object.values(PLACEMENT_OVERVIEW_TABS).includes(tab as PlacementOverviewTab);
